/**
 * Client-safe types + label map for /cee pages.
 * Heavy CEE_OPERATIONS array lives in cee-data.server.ts.
 */

export interface CEEOperation {
  slug: string
  code: string
  name: string
  category: 'chauffage' | 'isolation' | 'ventilation' | 'eau-chaude' | 'solaire'
  shortDesc: string
  montantClassique: string
  montantPrecarite: string
  requirement: string
  certification: string
  description: string
  conditions: string[]
  avantages: string[]
  pieges: string[]
  faq: Array<{ q: string; a: string }>
  aiClaims?: string[]
}

export const CATEGORY_LABELS: Record<CEEOperation['category'], string> = {
  chauffage: 'Chauffage',
  isolation: 'Isolation',
  ventilation: 'Ventilation',
  'eau-chaude': 'Eau chaude sanitaire',
  solaire: 'Solaire',
}
